export const numberRegex = /^\d+$/;
